const paginators = document.querySelectorAll('.page-navigator');

paginators.forEach(paginator => {
  paginator.addEventListener('click', e => {
    const pageId = e.target.dataset.page;
    const pageUp = parseInt(pageId) + 10;
    const pageDown = parseInt(pageId) - 10;

    paginators.forEach(p => {
      // Both marks, or the current page reads at 2.67:1 against the orange.
      p.classList.remove('bg-orange-mpf', 'text-white');
      p.classList.remove('hidden');
      if (p.dataset.page >= pageUp || p.dataset.page <= pageDown) {
        p.classList.add('hidden');
      }
    });
    paginator.classList.add('bg-orange-mpf', 'text-white');
  });
});
